import React, { useState } from "react";
import { HiOutlineMusicalNote } from "react-icons/hi2";

interface SongArtworkProps {
  /** Image URL - when null/undefined/empty, shows placeholder */
  src?: string | null;
  alt: string;
  className?: string;
  /** Icon size for placeholder - e.g. "w-10 h-10" or "w-16 h-16" */
  iconClassName?: string;
}

/**
 * Displays song artwork with error fallback.
 * Shows a music-note placeholder when image fails to load or when no URL.
 */
export const SongArtwork: React.FC<SongArtworkProps> = ({
  src,
  alt,
  className = "",
  iconClassName = "w-10 h-10",
}) => {
  const [imgError, setImgError] = useState(false);
  const showPlaceholder = !src || imgError;

  if (showPlaceholder) {
    return (
      <div
        className={`flex items-center justify-center rounded-xl bg-gray-100 dark:bg-gray-700 text-gray-400 dark:text-gray-500 shrink-0 ${className}`}
        aria-hidden
      >
        <HiOutlineMusicalNote className={iconClassName} strokeWidth={1.5} />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      onError={() => setImgError(true)}
      className={`rounded-xl object-cover shrink-0 shadow-sm ${className}`}
    />
  );
};
